module.exports = "<app-archive-edit-template on-cancel=$ctrl.cancel() on-save=$ctrl.save() archive=$ctrl.archive switch-tab-prefix=app.archivecreate> </app-archive-edit-template> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/archive/create/partial.html
// module id = 393
// module chunks = 0